import { ClientStatus, UserStatus } from '@core/generated/gql-types';

/**
 * Get Tailwind CSS styles for styling status badges based on status.
 * @param status ClientStatus or UserStatus to get styles for.
 * @returns classes for styling status badges.
 */
export const getStatusStyles = (status?: ClientStatus | UserStatus) => {
  switch (status) {
    case ClientStatus.Active || UserStatus.Active:
      return 'bg-green-100 text-green-800';
    case ClientStatus.Pending || ClientStatus.Inactive || UserStatus.Suspended:
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
